// TODO: remove the featureEnabled flag when the actions are implemented in JET-551 and JET-522
import { Dropdown, TDropdownElementProps } from '../../../../ui-toolkit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisVertical } from '@fortawesome/pro-regular-svg-icons';
import React from 'react';

export const MobilityActionsButton = ({
  onClick,
  showMenu,
  featureEnabled,
}: {
  onClick: () => void;
  showMenu: boolean;
  featureEnabled: boolean;
}) => {
  let mobilityActionItems: TDropdownElementProps[] = [
    {
      children: 'Change Order Type',
      onClick: () => {},
    },
    {
      children: 'Associate Existing Order',
      onClick: () => {},
    },
    {
      children: 'Remove from Group',
      onClick: () => {},
    },
  ];

  if (!featureEnabled) {
    return <></>;
  }

  return (
    <>
      <button
        onClick={onClick}
        className="bg-green-50 rounded-full w-7 h-7 border border-gray-400"
        data-testid={'mobility-header-actions'}
      >
        <FontAwesomeIcon icon={faEllipsisVertical} size="sm" />
      </button>
      {
        <Dropdown
          show={showMenu}
          items={mobilityActionItems}
          zIndex={999}
          position={{
            anchor: 'top-left',
            x: -200,
            y: 0,
          }}
        />
      }
    </>
  );
};
